import { RESULT_PALETTE, ReportResult } from "@/constants/report-result";
import { cn } from "@/lib/utils";

// Report-result badge (positive / negative / neutral). Reads the central
// RESULT_PALETTE so label + color stay consistent everywhere.
export const ResultBadge = ({
  result,
  className,
}: {
  result: ReportResult | string;
  className?: string;
}) => {
  const r = RESULT_PALETTE[result as ReportResult];
  return (
    <span
      className={cn(
        "shrink-0 rounded px-1.5 py-0.5 text-xs font-medium",
        r?.color || "bg-muted text-muted-foreground",
        className,
      )}
    >
      {r?.label ?? result}
    </span>
  );
};

export default ResultBadge;
